import React from "react";
import { Link } from "react-router-dom";


const DrawerMenu = ({ isMenuOpen, toggleMobileMenu }) => {

    // 솔루션 메뉴 클릭 핸들러
    // const handleNotYetClick = (e) => {
    //     e.preventDefault(); // 기본 동작 방지
    //     alert("준비중입니다.");
    // };
  
    // 메뉴 항목 클릭 핸들러
    const handleMenuClick = () => {
        toggleMobileMenu(); // 메뉴 닫기
    };

  return (
	<div className={`drawer-box ${isMenuOpen ? "open" : ""}`}>
		<div className="top">
			<button type="button" className="btn close" onClick={toggleMobileMenu}/>
		</div>

		<div className="drawer-menu">
			<ul className="drawer-group">
				<li className="drawer-item">
					<span>회사소개</span>
					<ul className="drawer-2dp-group">
						<li className="drawer-2dp-item">
							<Link to="/introduce/ceo" onClick={handleMenuClick}>CEO 인사말</Link>
						</li>
						<li className="drawer-2dp-item">
							<Link to="/introduce/history" onClick={handleMenuClick}>연혁</Link>
						</li>
						<li className="drawer-2dp-item">
							<Link to="/introduce/award" onClick={handleMenuClick}>수상 · 인증</Link>
						</li>
						<li className="drawer-2dp-item"> 
							<Link to="/introduce/business" onClick={handleMenuClick}>사업분야</Link>
						</li>
					</ul>
				</li>
				<li className="drawer-item">
					{/* <span>솔루션</span> */}
                    <Link to="/solutions/solution" onClick={handleMenuClick}>솔루션</Link>
					<ul className="drawer-2dp-group">
						<li className="drawer-2dp-item">
							<Link to="/solutions/modelin" onClick={handleMenuClick}>ModelIN</Link>
						</li>
						<li className="drawer-2dp-item">
							<Link to="/solutions/linkin" onClick={handleMenuClick}>LinkIN</Link>
						</li>
						<li className="drawer-2dp-item">
							<Link to="/solutions/openin" onClick={handleMenuClick}>OpenIN</Link>
						</li>
						<li className="drawer-2dp-item">
							<Link to="/solutions/collectin" onClick={handleMenuClick}>CollectIN</Link>
						</li>
					</ul>
				</li>
				<li className="drawer-item">
					<Link to="/career" onClick={handleMenuClick}>채용안내</Link>
				</li>
				<li className="drawer-item">
					<Link to="/contact">문의하기</Link>
				</li>
			</ul>
		</div>
	</div>
  );
};

export default DrawerMenu;
